<template>
  <div>
    <div v-for="(field, i) in service.fields" :key="i" class="flex flex-col gap-3 text-left">
      <p class="text-body-small-m">{{ field.label }}</p>
      <div v-for="(option, index) in field.options" :key="option">
        <div class="flex cursor-pointer gap-2.5" @click="toggleOption(option.key)">
          <SelectCheckbox :active-value="isSelected(option.key)" :title="option.label" />
        </div>
        <Divider v-if="index !== field.options.length - 1" class="mt-3" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    service: any;
  }>();

  onMounted(() => {
    if (!array.value) {
      array.value = [];
    }
  });
  const isSelected = (key: string) => {
    if (!array.value) {
      return false;
    }
    if (array.value.length === 0) {
      return false;
    }
    return array.value.includes(key);
  };
  const toggleOption = (key: string) => {
    if (array.value.includes(key)) {
      array.value = array.value.filter((item: string) => item !== key);
    } else {
      array.value.push(key);
    }
  };
  const { value: array } = useField(() => `services.${props.service.carrier_key}.array`, undefined, {
    syncVModel: false,
    controlled: true,
  });
</script>
